import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
    WorkplaceInterface,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import {RootState} from '../../reducer';
import {FormControl, InputLabel, MenuItem, MenuList, Pagination, Select} from '@mui/material';
import TextField from '@mui/material/TextField';
import {useNavigate} from 'react-router-dom';
import {PostInterface} from '../../interface/post.interface';
import PostListTable from './table/PostListTable';
import {MenuInterface} from "../../interface/menu.interface";
import PostShareListTable from "./table/PostShareListTable";
import {Club} from "../../interface/club.interface";
import Paper from "@mui/material/Paper";
import {Department} from "../../interface/department.interface";
import SuggestBoardDialog from "../dialog/SuggestBoardDialog";
import PostFleaMarketListTable from "./table/PostFleaMarketListTable";
import {FleaMarket} from "../../interface/fleaMarket.interface";

interface State {
    searchType: string,
    searchKeyword: string,
    totalCount: number,
    sortType: string,
    postList: PostInterface[],
    page: number,
    limit: number,
    menu: MenuInterface,
    clubList: Club[],
    departmentList: Department[],
    fleaMarketList: FleaMarket[],
    openFleaMarket: FleaMarket,
    selectedWorkplace: number
}

const initState: State = {
    sortType: constance.sortType.lastly,
    searchType: constance.searchType.title,
    searchKeyword: '',
    totalCount: 0,
    postList: [],
    page: 1,
    limit: 10,
    menu: {
        id: "",
        index: 0,
        name: "",
        path: "",
        subMenu: [],
        viewComment: false,
        placeholder: "",
        allowAdminReply: false,
        allowAdminPost: false,
    },
    clubList: [],
    departmentList: [],
    fleaMarketList: [],
    openFleaMarket: {
        _id: "",
        createdAt: new Date(),
        end: new Date(),
        openYN: "",
        start: new Date(),
        title: "",
        usage: "",
        workplace: ""
    },
    selectedWorkplace: -1,
};

export default function PostList() {
    console.log('[PostList]');
    const [state, setState] = useState<State>(initState);
    const commonData = useSelector((state: RootState) => state.commonData);
    const navigate = useNavigate();
    let {id, workplace, no, page, club, department, keyword, searchType, limit} = common.getQuery();

    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);
    let ref: any = useRef();


    useEffect(() => {
    }, [])

    useEffect(() => {
        getPostList();
        // 플리마켓 기간 체크

    }, [commonData.urlPath, page, limit, id, workplace, state.sortType, club, department, keyword, searchType]);


    /* 게시글 리스트 */
    function getPostList() {
        axios.get(constance.api.getPostList, {
            params: {
                id: id,
                workplace: workplace,
                page: page,
                limit: limit,
                searchKeyword: keyword,
                searchType: searchType,
                sortType: state.sortType,
                club: club,
                department: department
            },
        }).then(value => {
            console.log(value);
            let menu = common.getMenuObject(id);

            /* 동호회 게시판일 경우 클럽 리스트 조회 */
            if (config.clubId === menu.id) {
                axios.get(constance.api.getClubList).then(v => {
                    console.log('constance.api.getClubList');
                    setState({
                        ...state,
                        postList: value.data.postList,
                        totalCount: value.data.totalCount,
                        clubList: v.data.clubList,
                        menu: menu,
                        selectedWorkplace: -1,
                        page: Number(page),
                        limit: Number(limit),
                    })
                })
            } else if (config.departmentId === menu.id) {
                axios.get(constance.api.getDepartmentList).then(v => {
                    console.log('constance.api.getDepartmentList');
                    for (let department of v.data.departmentList) {
                        if (department.departmentName.match(/\(아산\)|\(담양\)|\(밀양\)|\(기흥\)|\(용인\)/g) != null) {
                            department.departmentName = department.departmentName.replace(/\(아산\)|\(담양\)|\(밀양\)|\(기흥\)|\(용인\)/g, "");
                        }
                    }

                    setState({
                        ...state,
                        postList: value.data.postList,
                        totalCount: value.data.totalCount,
                        departmentList: v.data.departmentList,
                        menu: menu,
                        selectedWorkplace: -1,
                        page: Number(page),
                        limit: Number(limit),
                    })
                })
            } else {
                let openFleaMarket = state.openFleaMarket;
                if (id == 'fleaMarket') {
                    for (let fleaMarket of value.data.fleaMarketList) {
                        if (fleaMarket.openYN == 'Y') {
                            openFleaMarket = fleaMarket;
                        }
                    }
                }

                setState({
                    ...state,
                    postList: value.data.postList,
                    totalCount: value.data.totalCount,
                    menu: menu,
                    selectedWorkplace: -1,
                    fleaMarketList: value.data.fleaMarketList,
                    openFleaMarket: openFleaMarket,
                    page: Number(page),
                    limit: Number(limit),
                });

            }
        }).catch(reason => {
            console.log(reason);
        });
    }

    /* 사업장 변경 */
    function handleChangeWorkplace(workplace: WorkplaceInterface) {

        // 동호회 게시판일 경우
        if ((config.departmentId === menu.id || config.clubId === menu.id) && workplace.value !== 0) {
            setState({
                ...state,
                selectedWorkplace: workplace.value == state.selectedWorkplace ? -1 : workplace.value
            })
        } else {
            // 일반
            navigate(`${config.url.board}?id=${id}&workplace=${workplace.value}&page=${page}&limit=${limit}&keyword=${keyword}&search-type=${searchType}`);
        }

    }

    /* 검색유형 변경 */
    const handleChangeSearchType = (e: any) => {
        navigate(`${config.url.board}?id=${id}&workplace=${workplace}&page=${page}&limit=${limit}&keyword=${keyword}&search-type=${e.target.value}`);
    };

    /* 검색 키워드 상태변경 */
    function handleChangeSearchKeyword(e: any) {
        navigate(`${config.url.board}?id=${id}&workplace=${workplace}&page=${1}&limit=${limit}&keyword=${e.target.value}&search-type=${searchType}`);
    }

    /* 검색 실행 */
    function handleSearch(e: any | null) {
        console.log(e)
        if (e.keyCode == 13 || e.type == 'click') {
            getPostList();
        }
    }

    /* 정렬 순서 */
    function handleChangeSortType(sortType: string) {
        setState({
            ...state,
            page: 1,
            sortType: sortType,
        });
    }

    /* 글쓰기 페이지 이동 */
    function handlePostWrite() {
        if (id == 'fleaMarket') {
            if (state.openFleaMarket == null || state.openFleaMarket._id == '') {
                common.alert('현재 진행 중인 플리마켓이 없습니다.', '', 'info');
            } else {
                navigate(`${config.url.postWrite}?id=${id}&fid=${state.fleaMarketList[0]._id}`);
            }

        } else {
            navigate(`${config.url.postWrite}?id=${id}`);
        }

    }

    /* 페이지 변경 */
    function changePagination(event: any, page: number) {
        if (page == 0) {
            page = event.target.value;
        }
        setState({
            ...state,
            page: page
        })
        navigate(`${config.url.board}?id=${id}&workplace=${workplace}&page=${page}&limit=${limit}&keyword=${keyword}&search-type=${searchType}&club=${club}&department=${department}`);
    }

    /* 게시글 수 변경 */
    function changePostLimit(event: any, limit: number) {
        if (limit == 0) {
            limit = event.target.value;
        }
        setState({
            ...state,
            limit: limit
        })
        navigate(`${config.url.board}?id=${id}&workplace=${workplace}&page=${page}&limit=${limit}&keyword=${keyword}&search-type=${searchType}&club=${club}&department=${department}`);
    }


    function getTable() {
        if (id == 'share') {
            /* 나눔 게시판*/
            return <PostShareListTable postList={state.postList}
                                       menu={state.menu}/>
        } else if (id == 'fleaMarket') {
            /* 플리마켓 게시판*/
            return <PostFleaMarketListTable postList={state.postList}
                                            menu={state.menu}
                                            fleaMarketList={state.fleaMarketList}/>
        } else {
            return <PostListTable postList={state.postList}
                                  menu={state.menu}/>
        }
    }

    /* 동호회 메뉴 선택 */
    function clickSubMenu(item: Department | Club, workplace: WorkplaceInterface, menuId: string) {
        setState({
            ...state,
            selectedWorkplace: -1
        })
        navigate(`${config.url.board}?id=${id}&workplace=${workplace.value}&page=${page}&limit=${limit}&keyword=${keyword}&search-type=${searchType}&${menuId}=${item._id}`);
    }

    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>

                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {
                        id == 'fleaMarket' ?
                            <Box sx={{width: 1,}}>
                                <img style={{width: '100%', borderRadius: 8}} src={'/images/flea-market-banner-2024.png'}/>
                            </Box>
                            : ''
                    }


                    {/* 사업장 선택이 있는 게시판일 경우 => 사업장 선택 버튼 생성 */}
                    <Box sx={{
                        display: config.workplaceBoardList.includes(id) ? 'flex' : 'none',
                        justifyContent: 'center', alignItems: 'center',
                        width: {xs: 1, sm: 1, md: 600}
                    }}>
                        {
                            Object.keys(constance.workplace).map((key, index) => {
                                const workplaceObject: any = constance.workplace;
                                const _workplace: WorkplaceInterface = workplaceObject[key];


                                let menuList: any = [];
                                /* 동호회 게시판 일 경우 */
                                const openClubMenu = config.clubId === menu.id && _workplace.value == state.selectedWorkplace;
                                if (openClubMenu) {
                                    for (let club of state.clubList) {
                                        if (_workplace.value == Number(club.workplace)) {
                                            menuList.push(club);
                                        }
                                    }
                                }

                                /* 부서모임 게시판 일 경우 */
                                const openDepartmentMenu = config.departmentId === menu.id && _workplace.value == state.selectedWorkplace;
                                console.log(`${config.departmentId} === ${menu.id} && ${_workplace.value} == ${state.selectedWorkplace}`)
                                if (openDepartmentMenu) {
                                    for (let department of state.departmentList) {
                                        if (_workplace.value == Number(department.workplace)) {
                                            menuList.push(department);
                                        }
                                    }
                                }

                                return (
                                    <Stack key={index} sx={{position: 'relative', width: {xs: 0.2, sm: 0.2, md: 80}}}>
                                        <Button variant={workplace === _workplace.value ? 'contained' : 'outlined'}
                                                color={'error'}
                                                onClick={() => handleChangeWorkplace(_workplace)}
                                                sx={{
                                                    mr: 1,
                                                    background: workplace === _workplace.value ? '#d32f2f' : 'var(--scc-surface)'
                                                }}>
                                            <Typography variant={"subtitle1"}>
                                                {_workplace.name}
                                            </Typography>
                                        </Button>

                                        {/* 게시판 ID가 부서모임, 동호회 경우 => 사업장별 동호회 리스트 메뉴리스트 */}
                                        {
                                            openClubMenu || openDepartmentMenu ?
                                                <Paper sx={{
                                                    position: 'absolute',
                                                    top: 40,
                                                    zIndex: 10,
                                                    maxHeight: 400,
                                                    overflowY: 'scroll',
                                                }}>
                                                    <MenuList>
                                                        {
                                                            menuList.map((item: any, i: number) => {
                                                                const border = i < (menuList.length - 1) ? styles.border : '0px';

                                                                return (
                                                                    <MenuItem key={i}
                                                                              onClick={() => clickSubMenu(item, _workplace, menu.id)}
                                                                              sx={{borderBottom: border}}>
                                                                        <Typography variant={fontSize}>
                                                                            {
                                                                                openClubMenu ?
                                                                                    `[${item.kind}] ${item.name}`
                                                                                    :
                                                                                    `${item.departmentName}`
                                                                            }
                                                                        </Typography>
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </MenuList>
                                                </Paper>
                                                : ''
                                        }
                                    </Stack>
                                );
                            })
                        }
                    </Box>

                    {/* 검색 카테고리 */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 600,
                        maxWidth: 1,
                        mt: 2,
                        mb: 2,
                    }}>
                        <Box sx={{width: {xs: 0.2, sm: 0.2, md: 100}, backgroundColor: 'var(--scc-surface)'}}>
                            <FormControl id={"search-form"} fullWidth size={isMobile ? 'small' : 'medium'}
                                         sx={{'>div': {height: isMobile ? 'inherit' : 52}}}>
                                <Select id={"search-select"}
                                        labelId="search-category"
                                        value={searchType}
                                        onChange={handleChangeSearchType}
                                >
                                    <MenuItem value={constance.searchType.title}>
                                        <Typography variant={isMobile ? 'caption' : 'subtitle1'}>제목</Typography>
                                    </MenuItem>
                                    <MenuItem value={constance.searchType.content}>
                                        <Typography variant={isMobile ? 'caption' : 'subtitle1'}>내용</Typography>
                                    </MenuItem>
                                    <MenuItem value={constance.searchType.creator}>
                                        <Typography variant={isMobile ? 'caption' : 'subtitle1'}>작성자</Typography>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{width: 3 / 5, ml: 1}}>
                            <TextField placeholder="검색어 입력"
                                       fullWidth
                                       size={isMobile ? 'small' : 'medium'}
                                       value={keyword}
                                       onChange={(e) => handleChangeSearchKeyword(e)}
                                       onKeyDown={(e) => handleSearch(e)}
                                       label="검색" variant="outlined"
                                       sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
                            />
                        </Box>

                        <Box sx={{
                            height: isMobile ? 1 : 52,
                            ml: 1,
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <Button variant={'contained'}
                                    color={'whiteOutlined'}
                                    size={isMobile ? 'small' : 'medium'}
                                    sx={{height: 1}}
                                    onClick={(e) => handleSearch(e)}>
                                <Typography variant={isMobile ? 'caption' : 'subtitle1'}>검색</Typography>
                            </Button>
                        </Box>
                    </Box>

                    {/* 게시판 리스트 */}
                    <Box sx={{
                        width: 1,
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        mt: 1
                    }}>
                        <Box sx={{display: 'flex'}}>
                            <Typography variant={fontSize}>총</Typography>
                            <Typography variant={fontSize}
                                        sx={{ml: 1, color: 'red', mr: 0.5}}>{state.totalCount}</Typography>
                            <Typography variant={fontSize}>건</Typography>
                        </Box>

                        <Box sx={{display: 'flex', position: 'absolute', right: 0, height: 1}}>
                            <Typography variant={fontSize} sx={{
                                cursor: 'pointer',
                                color: state.sortType === constance.sortType.lastly ? 'orangered' : 'inherit',
                                fontWeight: state.sortType === constance.sortType.lastly ? 500 : 'inherit',
                            }}
                                        onClick={() => handleChangeSortType(constance.sortType.lastly)}>
                                최신순
                            </Typography>
                            <Box sx={{height: 1, border: styles.border, mr: 1, ml: 1}}/>
                            <Typography variant={fontSize} sx={{
                                cursor: 'pointer',
                                color: state.sortType === constance.sortType.hitCount ? 'orangered' : 'inherit',
                                fontWeight: state.sortType === constance.sortType.hitCount ? 500 : 'inherit',
                            }}
                                        onClick={() => handleChangeSortType(constance.sortType.hitCount)}>
                                조회수
                            </Typography>
                            {
                                id == 'share' || id == 'fleaMarket' ?
                                    <>
                                        <Box sx={{height: 1, border: styles.border, mr: 1, ml: 1}}/>
                                        <Typography variant={fontSize} sx={{
                                            cursor: 'pointer',
                                            color: state.sortType === constance.sortType.onSale ? 'orangered' : 'inherit',
                                            fontWeight: state.sortType === constance.sortType.onSale ? 500 : 'inherit',
                                        }}
                                                    onClick={() => handleChangeSortType(constance.sortType.onSale)}>
                                            {
                                                id == 'share'? "나눔 중" : "판매 중"
                                            }
                                        </Typography>
                                        <Box sx={{height: 1, border: styles.border, mr: 1, ml: 1}}/>
                                        <Typography variant={fontSize} sx={{
                                            cursor: 'pointer',
                                            color: state.sortType === constance.sortType.soldOut ? 'orangered' : 'inherit',
                                            fontWeight: state.sortType === constance.sortType.soldOut ? 500 : 'inherit',
                                        }}
                                                    onClick={() => handleChangeSortType(constance.sortType.soldOut)}>
                                            {
                                                id == 'share'? "나눔 완료" : "판매 완료"
                                            }
                                        </Typography>
                                    </>
                                    : ''
                            }

                        </Box>
                    </Box>


                    {/* 게시글 목록 */}
                    <Box sx={{mt: 2, width: 1}}>
                        {
                            getTable()
                        }
                    </Box>


                    {/* 페이징 */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mt: 2,
                        mb: 1
                    }}>
                        <Stack spacing={1}>
                            <Pagination
                                count={Math.ceil(state.totalCount / limit)}
                                variant="outlined"
                                page={state.page}
                                shape={'rounded'}
                                boundaryCount={isMobile ? 1 : 2}
                                onChange={changePagination}/>
                        </Stack>
                        <Box sx={{display: 'flex', ml: isMobile ? 0 : 2, mt: isMobile ? 2 : 0}}>
                            <FormControl sx={{ml: 2}}>
                                <InputLabel>페이지</InputLabel>
                                <Select
                                    value={state.page}
                                    label="페이지"
                                    size={"small"}
                                    onChange={(event) => changePagination(event, 0)}
                                >
                                    {
                                        new Array(Math.ceil(state.totalCount / limit)).fill(0).map((value, index) => {
                                            return <MenuItem value={index + 1}>{index + 1}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>

                            <FormControl sx={{ml: 2}}>
                                <InputLabel>게시글 수</InputLabel>
                                <Select
                                    value={state.limit}
                                    label="게시글 수"
                                    size={"small"}
                                    onChange={(event) => changePostLimit(event, 0)}
                                >
                                    <MenuItem value={10}>{10}</MenuItem>
                                    <MenuItem value={20}>{20}</MenuItem>
                                    <MenuItem value={50}>{50}</MenuItem>
                                    <MenuItem value={100}>{100}</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>


                    {/* 하단 글쓰기 */}
                    {
                        (state.menu.allowAdminPost == false || (state.menu.allowAdminPost && commonData.user.admin)) && ((id != 'all' && id != '')) ?
                            <Box sx={{width: 1, display: 'flex', mt: 2, justifyContent: 'flex-end'}}>
                                <Button variant={'outlined'}
                                        color={'whiteOutlined'}
                                        onClick={handlePostWrite}
                                >
                                    <Typography>글쓰기</Typography>
                                </Button>
                            </Box>
                            : ""
                    }

                </Stack>

                {/* 건의게시판 게시판*/}
                {
                    id == 'suggest' ? <SuggestBoardDialog/> : ''
                }

            </Box>
        </>
    );
}
